import request from '@/utils/request'
import { toCmsContent, mapPageResult, mapSingleResult } from './helpers'

// 学生活动 (STUDENT)
export function getActiveList (params) {
  // 有搜索关键词时使用搜索接口，否则使用列表接口
  const endpoint = params && params.keyword ? '/api/cms/search' : '/api/cms/list'
  return request.get(endpoint, {
    params: { ...params, type: 'STUDENT' }
  }).then(mapPageResult)
}

export function getActiveDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addStudentActivity (data) {
  return request.post('/api/cms', toCmsContent(data, 'STUDENT'))
}

export function updateStudentActivity (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'STUDENT'))
}

export function deleteStudentActivity (id) {
  return request.delete(`/api/cms/${id}`)
}

// 招生信息 (ADMISSION)
export function getAdmissionInfo () {
  return request.get('/api/cms/list', {
    params: { type: 'ADMISSION', page: 1, pageSize: 1 }
  }).then(res => {
    // 取第一条，并转换格式
    if (res.code === 1 && res.data && res.data.rows && res.data.rows.length > 0) {
      const transformed = mapSingleResult({ ...res, data: res.data.rows[0] })
      res.data = transformed.data
    }
    return res
  })
}

export function updateAdmissionInfo (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'ADMISSION'))
}
